module.exports = __webpack_public_path__ + "static/about3-16a0ef88dc88abb1fd6aa086c0c9ad9a.jpg";